import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/BlogPost.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.35_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
